/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDetailShipping_shipmentQuote$ref = any;
export type PdpRespShippingReturns_shipmentQuote$ref = any;
export type PdpRespShippingReturns_shipmentQuote = {
    readonly " $fragmentRefs": PdpSharedDetailShipping_shipmentQuote$ref;
    readonly " $refType": PdpRespShippingReturns_shipmentQuote$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_shipmentQuote",
      "args": null
    }
  ]
};
(node as any).hash = '4838708062e93030ab0806d9793b8fff';
export default node;
